module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.address.phone) ? _c('div', {
    staticClass: "address flex-between",
    on: {
      "click": function($event) {
        _vm.addressPickerShow = true
      }
    }
  }, [_c('div', {
    staticClass: "address-left flex-start"
  }, [_c('img', {
    staticClass: "address-img",
    attrs: {
      "src": require("../../../assets/newImg/icon-address-location.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "address-detail"
  }, [_c('div', {
    staticClass: "address-pro"
  }, [_vm._v(_vm._s(_vm.address.address))]), _vm._v(" "), _c('div', {
    staticClass: "address-phone"
  }, [_vm._v(_vm._s(_vm.address.name) + " " + _vm._s(_vm.address.phone))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "address-back"
  })]) : _c('div', {
    staticClass: "address flex-between",
    on: {
      "click": function($event) {
        _vm.addressPickerShow = true
      }
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "address-back"
  })]), _vm._v(" "), _c('AddressPicker', {
    attrs: {
      "show": _vm.addressPickerShow
    },
    on: {
      "onChange": _vm.changeAddress,
      "onClose": _vm.closeAddress
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-right"
  }, [_c('img', {
    staticClass: "icon-right-tip",
    attrs: {
      "src": require("../../../assets/images/icon-right.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-left flex-start"
  }, [_c('img', {
    staticClass: "address-img",
    attrs: {
      "src": require("../../../assets/newImg/icon-address-location.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "address-detail"
  }, [_c('div', {
    staticClass: "address-pro"
  }, [_vm._v("请选择地址")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-right"
  }, [_c('img', {
    staticClass: "icon-right-tip",
    attrs: {
      "src": require("../../../assets/images/icon-right.png"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cb17538","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyAddress.vue
// module id = 2251
// module chunks = 0